export const TYPE = {
  FIRST_APPLICATION: 1,
  DAY_HOUR: 2,
  DAY_SHIFT: 3,
  WEEK_HOUR: 4,
  WEEK_SHIFT: 5,
  MONTH_HOUR: 6,
  MONTH_SHIFT: 7
};
